<template>
	<section class="app-container app-users">
		<div class="container">
			<h1>Odonata Central Users</h1>
			<div v-if="current_user">
				<div v-if="!loading_user">
					<div class="row">
						<div class="col-lg-6">
							<Paging></Paging>
							<PagingSummary v-model="meta"></PagingSummary>
						</div>
						<div class="col-lg-6">
							<br />
							<label>Search</label>
							<input v-model="search" type="text" />
						</div>
					</div>
					<div class="loading-overlay" v-show="loading">
						<div class="spinner-wrapper">
							<span class="spinner-text">LOADING</span>
							<span class="spinner"></span>
						</div>
					</div>
					<div class="table-responsive">
						<table class="table-users border--round table--alternate-row">
							<thead>
								<tr>
									<th>User Name</th>
									<th>Last Name</th>
									<th>First Name</th>
									<th>Location</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="user in users">
									<td>
										{{user.display_name}}
									</td>
									<td>{{user.last_name}}</td>
									<td>{{user.first_name}}</td>
									<td>
										<span v-if="user.profile && user.profile.city && user.profile.state_province">
											{{user.profile.city}}, {{user.profile.state_province}}
										</span>
									</td>
									<td>
										<router-link class="btn btn-xs" :to="{ name: 'profile', params: { id: user.id }}">View Profile</router-link>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<Paging></Paging>
				</div>
			</div>
			<div v-else>
				<div class="alert">
					<div class="alert__body">
						<span>Please login to view the member directory.</span>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import global_data from '../../main';
import _ from 'lodash'
export default {
	name: 'Users',
	metaInfo: {
      title: 'Users & Contributors',
      meta: [
        { name: "description", content: 'Users and people who have contributed to the Odonata Central project and citizen science efforts.' },
      ],
    },
	data: function(){
		return {
			loading:true,
			loading_user: true,
			current_user: null,
			users: null,
			meta: {
				page: 0,
				per_page: 0,
				total_pages: 0,
				total_results: 0,
			},
			page: null,
			search: "",
		};
	},
	mounted(){
		var parsed_page = parseInt(this.$route.query.page);
		if (!isNaN(parsed_page)) {
			this.page = parsed_page;
		}
		else{
			this.page = 1;
		}

		var self = this;

		this.GetAPIUser(function(user){
			if (user) {
				self.current_user = user;
				// self.getData();
				self.loading_user = false;
			}
			else{
				global_data.$on("user_changed", function(new_user){
					if (!self.current_user) {
						if (new_user) {
							self.current_user = new_user;
							self.getData();
							self.loading_user = false;
						}
					}
				});
				self.loading = false;
			}
		});
	},
	methods:{
		searchUsers: _.throttle( function () {
			this.getData();
	    },800),
		getData: function(){
			var self = this;
			self.loading = true;
			var qs = '&sort[]=last_name&sort[]=first_name';
			qs += "&page=" + self.page;

			if (self.search && self.search != "") {
				qs += "&search="+self.search;
			}
			this.API({
				endpoint: 'users',
				querystring: qs,
				funcThen: function(response){
					self.meta = response.data.meta;
					self.users = response.data.users;
					self.loading = false;
				},
			});
		},
	},
	computed: {
		max_page: function(){
			return this.meta.total_pages;
		}
	},
	watch:{
		page: function(){
			let query = Object.assign({}, this.$route.query);
			query.page = this.page;
			this.$router.replace({query: query});
			this.getData();
		},
		search: function(){
			this.searchUsers();
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Users.vue